import { Skeleton, Stack } from "@mui/material";

const SkeletonLoader = () => {
  return (
    <Stack className="SKELETON_LOADER" sx={{ width: "100%", height: "100%" }}>
      <Skeleton height="100%" sx={{ maxHeight: "4rem" }} />
      <Skeleton height="100%" />
      <Skeleton height="100%" sx={{ maxHeight: "4rem" }} />
    </Stack>
  );
};

export default SkeletonLoader;
